import React from 'react';

interface Props {
    header: React.ReactNode;
    extra?: React.ReactNode;
    theme?: any;
}
export default class ContentGroup extends React.PureComponent<Props> {
    render() {
        const { header, children, extra, theme } = this.props;

        return (
            <div className="ct-content-group">
                {header && (
                    <div
                        className="ct-content-group__header"
                        style={theme?.isDarkMode ? { borderColor: `${theme.themeColor}66` } : undefined}
                    >
                        <div className="ct-content-group__header-content">{header}</div>
                        {extra && <div className="ct-content-group__header-extra">{extra}</div>}
                    </div>
                )}
                <div className="ct-content-group__content">{children}</div>
            </div>
        );
    }
}
